<script lang="ts">
    import { getDashboardCtx } from "../../state/dashboard.svelte";
    import { translate } from "@/utils/format";
    import { goTo } from "@/utils/router";

    const store = getDashboardCtx();
</script>

<div class="referrals__creatives">
    <h4>
        {translate(
            "PARTNER_CREATIVITIES_TITLE",
            "Generar creatividades",
        )}
    </h4>
    <p class="creatives-description">
        {translate(
            "PARTNER_CREATIVITIES_DESC",
            "Crea imágenes promocionales con tu QR y tu logo para compartir en redes.",
        )}
    </p>
    <button
        class="button --primary"
        onclick={() => goTo("/creativityGenerator")}
    >
        <i class="fal fa-image"></i>
        {translate(
            "PARTNER_CREATIVITIES_OPEN",
            "Abrir generador",
        )}
    </button>
</div>
